import { render } from "./form-add-organization.vue?vue&type=template&id=b33cb9ee"
import script from "./form-add-organization.vue?vue&type=script&lang=js"
export * from "./form-add-organization.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__